<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1106214920
     */
    const props = defineProps<IWidgetProps<TypeFormData>>();
    const { data, cmsComponentProps } = useWidget(props);
    const isTypeformReady = ref(false);

    onBeforeMount(() => {
        if (window.woomTypeFormLoaded) {
            isTypeformReady.value = true;
            return;
        }

        useHead({
            script: [
                {
                    src: `https://embed.typeform.com/next/embed.js`,
                    async: true,
                    onload: () => {
                        window.woomTypeFormLoaded = true;
                        isTypeformReady.value = true;
                    },
                },
            ],
        });
    });
</script>
<template>
    <mol-section
        v-if="data.code && isTypeformReady"
        v-bind="cmsComponentProps">
        <div class="min-h-[70dvh]">
            <renderer-html :content="data.code" />
        </div>
    </mol-section>
</template>
